/*! @azure/msal-react v2.0.1 2023-08-11 */
'use strict';

import _objectSpread from "/opt/Talento100/talento100_frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React__default from 'react';
import { useMsal } from '../hooks/useMsal.js';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Higher order component wraps provided component with msal by injecting msal context values into the component's props
 * @param Component
 */

var withMsal = function withMsal(Component) {
  var ComponentWithMsal = function ComponentWithMsal(props) {
    var msal = useMsal();
    return React__default.createElement(Component, _objectSpread(_objectSpread({}, props), {}, {
      msalContext: msal
    }));
  };

  var componentName = Component.displayName || Component.name || "Component";
  ComponentWithMsal.displayName = "withMsal(".concat(componentName, ")");
  return ComponentWithMsal;
};

export { withMsal };